import styled from 'styled-components';

import SkewedButton from '@components/buttons/SkewedButton';
import { DefaultText } from '@components/text';

const StyledContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
`;

const StyledFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledButton = styled(SkewedButton)`
  width: 100%;
  padding: 4px 24px;
`;

const StyledErrorContainer = styled.div`
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-block: 4px;
`;

const StyledErrorText = styled(DefaultText)`
  color: ${({ theme }) => theme.colors.red[500]};
  font-size: ${({ theme }) => theme.fonts.fontSize.sm};
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export {
  StyledContainer,
  StyledForm,
  StyledFormContainer,
  StyledButton,
  StyledErrorContainer,
  StyledErrorText,
};
